/**
 * TODO: documentazione
 * @param str
 */
export const capitalize = <T extends string>(str: T): Capitalize<Lowercase<T>> => {
  return str.charAt(0).toUpperCase().concat(str.slice(1).toLowerCase()) as Capitalize<Lowercase<T>>;
};
